// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__WhNMg","col":"styles_col__1YvWN"};